<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "First Name",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sourceOfFundsProviderFirstName`,
					props: {
						suggest: {
							typeIncludes: `sourceOfFundsProviderFirstName`
						},
						createOptions: {
							type: `sourceOfFundsProviderFirstName`,
							dataType: "string"
						}
					}
				},
				{
					label: "Last Name",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sourceOfFundsProviderLastName`,
					props: {
						suggest: {
							typeIncludes: `sourceOfFundsProviderLastName`
						},
						createOptions: {
							type: `sourceOfFundsProviderLastName`,
							dataType: "string"
						}
					}
				},
				{
					label: "Relationship to Proposed Life Insured",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sourceOfFundsProviderRelationship`,
					props: {
						suggest: {
							typeIncludes: `sourceOfFundsProviderRelationship`
						},
						createOptions: {
							type: `sourceOfFundsProviderRelationship`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
